// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2ZThZ","savePackageButton":"ClientWallet_savePackageButton__278u_"};